'use strict';

import * as dom from './lib/dom.js';

function stickFooter() {

	const footer = document.querySelector('.o-footer');
	// const header = document.querySelector('.c-header-ghost ');

	let footerHeight = footer.offsetHeight;
	// let headerHeight = header.offsetHeight;
	const content = document.querySelector('.c-wrapper');

	// let excludeHeight = footerHeight + headerHeight;

	// console.log('altura excluida ' + excludeHeight);
	// console.log('altura footer ' + footerHeight);
	// console.log('altura header ' + headerHeight);

	content.style.minHeight = 'calc(100vh - '+ footerHeight +'px)';
	// console.log(content.style.height);

};

export default function() {
	window.addEventListener('load', function() {
		stickFooter();
	});

	window.addEventListener('resize', function() {
		stickFooter();
	});
};
